<template>
  <v-card class="elevation-0 px-2 py-2">
    <v-card-text class="px-0">
      <v-row class="mb-1 ta-center">
        <v-col>
          <div class="c-dark-blue fs-18 fw-500 mb-1">Help us understand your needs</div>
          <div class="c-dark-blue fs-26 fw-600 mb-2">What best describes you as a parent?</div>
        </v-col>
      </v-row>
      <div class="mx-auto mxw-400">
        <v-row class="mb-2">
          <v-btn :class="search.stage == 0 ? pressed : not" @click="search.stage = 0" class="fullwidth">Planning for the future</v-btn>
        </v-row>
        <v-row class="mb-2">
          <v-btn :class="search.stage == 1 ? pressed : not" @click="search.stage = 1" class="fullwidth">Expecting my first child</v-btn>
        </v-row>
        <v-row class="mb-2">
          <v-btn :class="search.stage == 2 ? pressed : not" @click="search.stage = 2" class="fullwidth">Have one or more children</v-btn>
        </v-row>
        <v-row>
          <v-btn :class="search.stage == 3 ? pressed : not" @click="search.stage = 3" class="fullwidth">Have children with another on the way</v-btn>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: function() {
    return {
      not: ['outlined', 'ghostly'],
      pressed: ['depressed', 'secondary'],
    }
  },

  props: ['search']
}
</script>
